// now we have to use react context api to maintain state in the application
import React, { createContext, useReducer } from "react";


// get initial state from local storage

export const initialState = {
    warehouse: null,
    warehouses: [],
    elements: [],
    initialLoad: false,
    viewportMode: null,
    FULLSCREEN_MODE_ENABLED: false,
    globalShowLocation:null,
    layoutEditor: {
        tool: 'selection',
        action: 'none',
        canvasDimensions: { width: 0, height: 0 },
        selectedElement: null,
        panOffset: { x: 0, y: 0 },
        zoom: 0.50,
        zoomCenter: { x: 0, y: 0 },
        startPanMousePosition: { x: 0, y: 0 },
        scaledOffset: { x: 0, y: 0 },
    },
    rackEditor: {
        elements: [],
        tool: 'selection',
        action: 'none',
        canvasDimensions: { width: 0, height: 0 },
        selectedElement: null,
        panOffset: { x: 0, y: 0 },
        zoom: 1,
        zoomCenter: { x: 0, y: 0 },
        startPanMousePosition: { x: 0, y: 0 },
        scaledOffset: { x: 0, y: 0 },
    },
    globalLoader:{
        isActive:false,
        loaderText:"Loading",
    }
}


export const Store = createContext(initialState);

